// Traverses through hierarchically structed aggregations, filtering all
// entries using the given `filterFunc`. When the filter function is empty,
// emits all items to the resulting Array. Traversal is continued through the
// children of a level when `continueFunc` is undefined or a given function
// returns `true`.

export default function traverse(aggregations, opts = {}) {
  const resultAggregations = [];

  function processLevel(aggregationsForLevel, depth) {
    aggregationsForLevel.forEach((aggregation) => {
      if (!opts.filter || opts.filter(aggregation, depth)) {
        resultAggregations.push(aggregation);
      }

      const continueTraversal = !opts.continue || opts.continue(aggregation, depth);

      if (aggregation.children && continueTraversal) {
        processLevel(aggregation.children, depth + 1);
      }
    });
  }

  processLevel(aggregations, 0);
  return resultAggregations;
}
